import GetMealsQuery from './GetMealsQuery';

export default GetMealsQuery;
